<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>匝道桥</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir-upchart">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir-upchart">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-a1" content="A1匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/A1"></router-link>
          </el-tooltip>

          <div class="stati sta-a1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorA1Dehumidifier, humidityAllowedMaxA1Dehumidifier, runningDehumidifierA1, "")
                }}
              </div>
              <div :class="errorA1Dehumidifier" class="state-info right-pos">
                <p>A1匝道除湿机</p>
                <p>
                  <span>{{ humidityA1Dehumidifier | toFixed }}% {{ temperatureA1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipA1" effect="light" placement="right"> -->
                  <span :class="runningClassA1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-a1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorA1Sensor1, humidityAllowedMaxA1Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorA1Sensor2, humidityAllowedMaxA1Sensor2) }}
              </div>
              <div :class="errorA1Sensor" class="state-info left-pos">
                <p>A1匝道传感器1/2</p>
                <p>
                  <span>{{ humidityA1Sensor1 | toFixed }}% {{ temperatureA1Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityA1Sensor2 | toFixed }}% {{ temperatureA1Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-a2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorA2Sensor1, humidityAllowedMaxA2Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorA2Sensor2, humidityAllowedMaxA2Sensor2) }}
              </div>
              <div :class="errorA2Sensor" class="state-info right-pos">
                <p>A2匝道传感器1/2</p>
                <p>
                  <span>{{ humidityA2Sensor1 | toFixed }}% {{ temperatureA2Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityA2Sensor2 | toFixed }}% {{ temperatureA2Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-a2" content="A2匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/A2"></router-link>
          </el-tooltip>
          <div class="stati sta-a2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorA2Dehumidifier, humidityAllowedMaxA2Dehumidifier, runningDehumidifierA2, "")
                }}
              </div>
              <div :class="errorA2Dehumidifier" class="state-info left-pos">
                <p>A2匝道除湿机</p>
                <p>
                  <span>{{ humidityA2Dehumidifier | toFixed }}% {{ temperatureA2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipA2" effect="light" placement="right"> -->
                  <span :class="runningClassA2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-d2" content="D2匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/D2"></router-link>
          </el-tooltip>
          <div class="stati sta-d2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorD2Dehumidifier, humidityAllowedMaxD2Dehumidifier, runningDehumidifierD2, "")
                }}
              </div>
              <div :class="errorD2Dehumidifier" class="state-info left-pos">
                <p>D2匝道除湿机</p>
                <p>
                  <span>{{ humidityD2Dehumidifier | toFixed }}% {{ temperatureD2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipD2" effect="light" placement="right"> -->
                  <span :class="runningClassD2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-d2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorD2Sensor1, humidityAllowedMaxD2Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorD2Sensor2, humidityAllowedMaxD2Sensor2) }}
              </div>
              <div :class="errorD2Sensor" class="state-info left-pos">
                <p>D2匝道传感器1/2</p>
                <p>
                  <span>{{ humidityD2Sensor1 | toFixed }}% {{ temperatureD2Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityD2Sensor2 | toFixed }}% {{ temperatureD2Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-d4" content="D4匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/D4"></router-link>
          </el-tooltip>
          <div class="stati sta-d4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorD4Dehumidifier, humidityAllowedMaxD4Dehumidifier, runningDehumidifierD4, "")
                }}
              </div>
              <div :class="errorD4Dehumidifier" class="state-info left-pos">
                <p>D4匝道除湿机</p>
                <p>
                  <span>{{ humidityD4Dehumidifier | toFixed }}% {{ temperatureD4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipD4" effect="light" placement="right"> -->
                  <span :class="runningClassD4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-d4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorD4Sensor1, humidityAllowedMaxD4Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorD4Sensor2, humidityAllowedMaxD4Sensor2) }}
              </div>
              <div :class="errorD4Sensor" class="state-info left-pos">
                <p>D4匝道传感器1/2</p>
                <p>
                  <span>{{ humidityD4Sensor1 | toFixed }}% {{ temperatureD4Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityD4Sensor2 | toFixed }}% {{ temperatureD4Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-e2" content="E2匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/E2"></router-link>
          </el-tooltip>
          <div class="stati sta-e2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorE2Dehumidifier, humidityAllowedMaxE2Dehumidifier, runningDehumidifierE2, "")
                }}
              </div>
              <div :class="errorE2Dehumidifier" class="state-info right-pos">
                <p>E2匝道除湿机</p>
                <p>
                  <span>{{ humidityE2Dehumidifier | toFixed }}% {{ temperatureE2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipE2" effect="light" placement="right"> -->
                  <span :class="runningClassE2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-e2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorE2Sensor1, humidityAllowedMaxE2Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorE2Sensor2, humidityAllowedMaxE2Sensor2) }}
              </div>
              <div :class="errorE2Sensor" class="state-info right-pos">
                <p>E2匝道传感器1/2</p>
                <p>
                  <span>{{ humidityE2Sensor1 | toFixed }}% {{ temperatureE2Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityE2Sensor2 | toFixed }}% {{ temperatureE2Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-e4" content="E4匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/E4"></router-link>
          </el-tooltip>
          <div class="stati sta-e4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorE4Dehumidifier, humidityAllowedMaxE4Dehumidifier, runningDehumidifierE4, "")
                }}
              </div>
              <div :class="errorE4Dehumidifier" class="state-info right-pos">
                <p>E4匝道除湿机</p>
                <p>
                  <span>{{ humidityE4Dehumidifier | toFixed }}% {{ temperatureE4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipE4" effect="light" placement="right"> -->
                  <span :class="runningClassE4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-e4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorE4Sensor1, humidityAllowedMaxE4Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorE4Sensor2, humidityAllowedMaxE4Sensor2) }}
              </div>
              <div :class="errorE4Sensor" class="state-info right-pos">
                <p>E4匝道传感器1/2</p>
                <p>
                  <span>{{ humidityE4Sensor1 | toFixed }}% {{ temperatureE4Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityE4Sensor2 | toFixed }}% {{ temperatureE4Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-b2" content="B2匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/B2"></router-link>
          </el-tooltip>
          <div class="stati sta-b2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorB2Dehumidifier, humidityAllowedMaxB2Dehumidifier, runningDehumidifierB2, "")
                }}
              </div>
              <div :class="errorB2Dehumidifier" class="state-info left-pos">
                <p>B2匝道除湿机</p>
                <p>
                  <span>{{ humidityB2Dehumidifier | toFixed }}% {{ temperatureB2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipB2" effect="light" placement="right"> -->
                  <span :class="runningClassB2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-b2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorB2Sensor1, humidityAllowedMaxB2Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorB2Sensor2, humidityAllowedMaxB2Sensor2) }}
              </div>
              <div :class="errorB2Sensor" class="state-info left-pos">
                <p>B2匝道传感器1/2</p>
                <p>
                  <span>{{ humidityB2Sensor1 | toFixed }}% {{ temperatureB2Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityB2Sensor2 | toFixed }}% {{ temperatureB2Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-b4" content="B4匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/B4"></router-link>
          </el-tooltip>
          <div class="stati sta-b4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorB4Dehumidifier, humidityAllowedMaxB4Dehumidifier, runningDehumidifierB4, "")
                }}
              </div>
              <div :class="errorB4Dehumidifier" class="state-info left-pos">
                <p>B4匝道除湿机</p>
                <p>
                  <span>{{ humidityB4Dehumidifier | toFixed }}% {{ temperatureB4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipB4" effect="light" placement="right"> -->
                  <span :class="runningClassB4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-b4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorB4Sensor1, humidityAllowedMaxB4Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorB4Sensor2, humidityAllowedMaxB4Sensor2) }}
              </div>
              <div :class="errorB4Sensor" class="state-info left-pos">
                <p>B4匝道传感器1/2</p>
                <p>
                  <span>{{ humidityB4Sensor1 | toFixed }}% {{ temperatureB4Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityB4Sensor2 | toFixed }}% {{ temperatureB4Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-c2" content="C2匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/C2"></router-link>
          </el-tooltip>
          <div class="stati sta-c2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorC2Dehumidifier, humidityAllowedMaxC2Dehumidifier, runningDehumidifierC2, "")
                }}
              </div>
              <div :class="errorC2Dehumidifier" class="state-info right-pos">
                <p>C2匝道除湿机</p>
                <p>
                  <span>{{ humidityC2Dehumidifier | toFixed }}% {{ temperatureC2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipC2" effect="light" placement="right"> -->
                  <span :class="runningClassC2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-c2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorC2Sensor1, humidityAllowedMaxC2Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorC2Sensor2, humidityAllowedMaxC2Sensor2) }}
              </div>
              <div :class="errorC2Sensor" class="state-info right-pos">
                <p>C2匝道传感器1/2</p>
                <p>
                  <span>{{ humidityC2Sensor1 | toFixed }}% {{ temperatureC2Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityC2Sensor2 | toFixed }}% {{ temperatureC2Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-c4" content="C4匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/C4"></router-link>
          </el-tooltip>
          <div class="stati sta-c4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorC4Dehumidifier, humidityAllowedMaxC4Dehumidifier, runningDehumidifierC4, "")
                }}
              </div>
              <div :class="errorC4Dehumidifier" class="state-info right-pos">
                <p>C4匝道除湿机</p>
                <p>
                  <span>{{ humidityC4Dehumidifier | toFixed }}% {{ temperatureC4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipC4" effect="light" placement="right"> -->
                  <span :class="runningClassC4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-c4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorC4Sensor1, humidityAllowedMaxC4Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorC4Sensor2, humidityAllowedMaxC4Sensor2) }}
              </div>
              <div :class="errorC4Sensor" class="state-info right-pos">
                <p>C4匝道传感器1/2</p>
                <p>
                  <span>{{ humidityC4Sensor1 | toFixed }}% {{ temperatureC4Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityC4Sensor2 | toFixed }}% {{ temperatureC4Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>匝道桥</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-d1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorD1Sensor1, humidityAllowedMaxD1Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorD1Sensor2, humidityAllowedMaxD1Sensor2) }}
              </div>
              <div :class="errorD1Sensor" class="state-info left-pos">
                <p>D1匝道传感器1/2</p>
                <p>
                  <span>{{ humidityD1Sensor1 | toFixed }}% {{ temperatureD1Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityD1Sensor2 | toFixed }}% {{ temperatureD1Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-d1" content="D1匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/D1"></router-link>
          </el-tooltip>
          <div class="stati sta-d1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorD1Dehumidifier, humidityAllowedMaxD1Dehumidifier, runningDehumidifierD1, "")
                }}
              </div>
              <div :class="errorD1Dehumidifier" class="state-info left-pos">
                <p>D1匝道除湿机</p>
                <p>
                  <span>{{ humidityD1Dehumidifier | toFixed }}% {{ temperatureD1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipD1" effect="light" placement="right"> -->
                  <span :class="runningClassD1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-d3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorD3Sensor1, humidityAllowedMaxD3Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorD3Sensor2, humidityAllowedMaxD3Sensor2) }}
              </div>
              <div :class="errorD3Sensor" class="state-info left-pos">
                <p>D3匝道传感器1/2</p>
                <p>
                  <span>{{ humidityD3Sensor1 | toFixed }}% {{ temperatureD3Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityD3Sensor2 | toFixed }}% {{ temperatureD3Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-d3" content="D3匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/D3"></router-link>
          </el-tooltip>
          <div class="stati sta-d3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorD3Dehumidifier, humidityAllowedMaxD3Dehumidifier, runningDehumidifierD3, "")
                }}
              </div>
              <div :class="errorD3Dehumidifier" class="state-info left-pos">
                <p>D3匝道除湿机</p>
                <p>
                  <span>{{ humidityD3Dehumidifier | toFixed }}% {{ temperatureD3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipD3" effect="light" placement="right"> -->
                  <span :class="runningClassD3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-e1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorE1Sensor1, humidityAllowedMaxE1Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorE1Sensor2, humidityAllowedMaxE1Sensor2) }}
              </div>
              <div :class="errorE1Sensor" class="state-info right-pos">
                <p>E1匝道传感器1/2</p>
                <p>
                  <span>{{ humidityE1Sensor1 | toFixed }}% {{ temperatureE1Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityE1Sensor2 | toFixed }}% {{ temperatureE1Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-e1" content="E1匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/E1"></router-link>
          </el-tooltip>
          <div class="stati sta-e1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorE1Dehumidifier, humidityAllowedMaxE1Dehumidifier, runningDehumidifierE1, "")
                }}
              </div>
              <div :class="errorE1Dehumidifier" class="state-info right-pos">
                <p>E1匝道除湿机</p>
                <p>
                  <span>{{ humidityE1Dehumidifier | toFixed }}% {{ temperatureE1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipE1" effect="light" placement="right"> -->
                  <span :class="runningClassE1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-e3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorE3Sensor1, humidityAllowedMaxE3Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorE3Sensor2, humidityAllowedMaxE3Sensor2) }}
              </div>
              <div :class="errorE3Sensor" class="state-info right-pos">
                <p>E3匝道传感器1/2</p>
                <p>
                  <span>{{ humidityE3Sensor1 | toFixed }}% {{ temperatureE3Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityE3Sensor2 | toFixed }}% {{ temperatureE3Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-e3" content="E3匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/E3"></router-link>
          </el-tooltip>
          <div class="stati sta-e3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorE3Dehumidifier, humidityAllowedMaxE3Dehumidifier, runningDehumidifierE3, "")
                }}
              </div>
              <div :class="errorE3Dehumidifier" class="state-info right-pos">
                <p>E3匝道除湿机</p>
                <p>
                  <span>{{ humidityE3Dehumidifier | toFixed }}% {{ temperatureE3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipE3" effect="light" placement="right"> -->
                  <span :class="runningClassE3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-b1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorB1Sensor1, humidityAllowedMaxB1Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorB1Sensor2, humidityAllowedMaxB1Sensor2) }}
              </div>
              <div :class="errorB1Sensor" class="state-info left-pos">
                <p>B1匝道传感器1/2</p>
                <p>
                  <span>{{ humidityB1Sensor1 | toFixed }}% {{ temperatureB1Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityB1Sensor2 | toFixed }}% {{ temperatureB1Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-b1" content="B1匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/B1"></router-link>
          </el-tooltip>
          <div class="stati sta-b1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorB1Dehumidifier, humidityAllowedMaxB1Dehumidifier, runningDehumidifierB1, "")
                }}
              </div>
              <div :class="errorB1Dehumidifier" class="state-info left-pos">
                <p>B1匝道除湿机</p>
                <p>
                  <span>{{ humidityB1Dehumidifier | toFixed }}% {{ temperatureB1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipB1" effect="light" placement="right"> -->
                  <span :class="runningClassB1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-b3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorB3Sensor1, humidityAllowedMaxB3Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorB3Sensor2, humidityAllowedMaxB3Sensor2) }}
              </div>
              <div :class="errorB3Sensor" class="state-info left-pos">
                <p>B3匝道传感器1/2</p>
                <p>
                  <span>{{ humidityB3Sensor1 | toFixed }}% {{ temperatureB3Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityB3Sensor2 | toFixed }}% {{ temperatureB3Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-b3" content="B3匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/B3"></router-link>
          </el-tooltip>
          <div class="stati sta-b3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorB3Dehumidifier, humidityAllowedMaxB3Dehumidifier, runningDehumidifierB3, "")
                }}
              </div>
              <div :class="errorB3Dehumidifier" class="state-info left-pos">
                <p>B3匝道除湿机</p>
                <p>
                  <span>{{ humidityB3Dehumidifier | toFixed }}% {{ temperatureB3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipB3" effect="light" placement="right"> -->
                  <span :class="runningClassB3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-c1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorC1Sensor1, humidityAllowedMaxC1Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorC1Sensor2, humidityAllowedMaxC1Sensor2) }}
              </div>
              <div :class="errorC1Sensor" class="state-info right-pos">
                <p>C1匝道传感器1/2</p>
                <p>
                  <span>{{ humidityC1Sensor1 | toFixed }}% {{ temperatureC1Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityC1Sensor2 | toFixed }}% {{ temperatureC1Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-c1" content="C1匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/C1"></router-link>
          </el-tooltip>
          <div class="stati sta-c1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorC1Dehumidifier, humidityAllowedMaxC1Dehumidifier, runningDehumidifierC1, "")
                }}
              </div>
              <div :class="errorC1Dehumidifier" class="state-info right-pos">
                <p>C1匝道除湿机</p>
                <p>
                  <span>{{ humidityC1Dehumidifier | toFixed }}% {{ temperatureC1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipC1" effect="light" placement="right"> -->
                  <span :class="runningClassC1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-c3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("传感器1", humidityTooltipErrorC3Sensor1, humidityAllowedMaxC3Sensor1) }}
                <br />
                {{ assembleTooltip_sensor("传感器2", humidityTooltipErrorC3Sensor2, humidityAllowedMaxC3Sensor2) }}
              </div>
              <div :class="errorC3Sensor" class="state-info right-pos">
                <p>C3匝道传感器1/2</p>
                <p>
                  <span>{{ humidityC3Sensor1 | toFixed }}% {{ temperatureC3Sensor1 | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ humidityC3Sensor2 | toFixed }}% {{ temperatureC3Sensor2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-c3" content="C3匝道除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/ramp/C3"></router-link>
          </el-tooltip>
          <div class="stati sta-c3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier("", humidityTooltipErrorC3Dehumidifier, humidityAllowedMaxC3Dehumidifier, runningDehumidifierC3, "")
                }}
              </div>
              <div :class="errorC3Dehumidifier" class="state-info right-pos">
                <p>C3匝道除湿机</p>
                <p>
                  <span>{{ humidityC3Dehumidifier | toFixed }}% {{ temperatureC3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipC3" effect="light" placement="right"> -->
                  <span :class="runningClassC3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      humidityTooltipErrorA1Dehumidifier: "--",
      humidityTooltipErrorA1Sensor1: "--",
      humidityTooltipErrorA1Sensor2: "--",
      humidityTooltipErrorA2Dehumidifier: "--",
      humidityTooltipErrorA2Sensor1: "--",
      humidityTooltipErrorA2Sensor2: "--",
      humidityTooltipErrorB1Dehumidifier: "--",
      humidityTooltipErrorB1Sensor1: "--",
      humidityTooltipErrorB1Sensor2: "--",
      humidityTooltipErrorB2Dehumidifier: "--",
      humidityTooltipErrorB2Sensor1: "--",
      humidityTooltipErrorB2Sensor2: "--",
      humidityTooltipErrorB3Dehumidifier: "--",
      humidityTooltipErrorB3Sensor1: "--",
      humidityTooltipErrorB3Sensor2: "--",
      humidityTooltipErrorB4Dehumidifier: "--",
      humidityTooltipErrorB4Sensor1: "--",
      humidityTooltipErrorB4Sensor2: "--",
      humidityTooltipErrorC1Dehumidifier: "--",
      humidityTooltipErrorC1Sensor1: "--",
      humidityTooltipErrorC1Sensor2: "--",
      humidityTooltipErrorC2Dehumidifier: "--",
      humidityTooltipErrorC2Sensor1: "--",
      humidityTooltipErrorC2Sensor2: "--",
      humidityTooltipErrorC3Dehumidifier: "--",
      humidityTooltipErrorC3Sensor1: "--",
      humidityTooltipErrorC3Sensor2: "--",
      humidityTooltipErrorC4Dehumidifier: "--",
      humidityTooltipErrorC4Sensor1: "--",
      humidityTooltipErrorC4Sensor2: "--",
      humidityTooltipErrorD1Dehumidifier: "--",
      humidityTooltipErrorD1Sensor1: "--",
      humidityTooltipErrorD1Sensor2: "--",
      humidityTooltipErrorD2Dehumidifier: "--",
      humidityTooltipErrorD2Sensor1: "--",
      humidityTooltipErrorD2Sensor2: "--",
      humidityTooltipErrorD3Dehumidifier: "--",
      humidityTooltipErrorD3Sensor1: "--",
      humidityTooltipErrorD3Sensor2: "--",
      humidityTooltipErrorD4Dehumidifier: "--",
      humidityTooltipErrorD4Sensor1: "--",
      humidityTooltipErrorD4Sensor2: "--",
      humidityTooltipErrorE1Dehumidifier: "--",
      humidityTooltipErrorE1Sensor1: "--",
      humidityTooltipErrorE1Sensor2: "--",
      humidityTooltipErrorE2Dehumidifier: "--",
      humidityTooltipErrorE2Sensor1: "--",
      humidityTooltipErrorE2Sensor2: "--",
      humidityTooltipErrorE3Dehumidifier: "--",
      humidityTooltipErrorE3Sensor1: "--",
      humidityTooltipErrorE3Sensor2: "--",
      humidityTooltipErrorE4Dehumidifier: "--",
      humidityTooltipErrorE4Sensor1: "--",
      humidityTooltipErrorE4Sensor2: "--",

      humidityAllowedMaxA1Dehumidifier: "--",
      humidityAllowedMaxA1Sensor1: "--",
      humidityAllowedMaxA1Sensor2: "--",
      humidityAllowedMaxA2Dehumidifier: "--",
      humidityAllowedMaxA2Sensor1: "--",
      humidityAllowedMaxA2Sensor2: "--",
      humidityAllowedMaxB1Dehumidifier: "--",
      humidityAllowedMaxB1Sensor1: "--",
      humidityAllowedMaxB1Sensor2: "--",
      humidityAllowedMaxB2Dehumidifier: "--",
      humidityAllowedMaxB2Sensor1: "--",
      humidityAllowedMaxB2Sensor2: "--",
      humidityAllowedMaxB3Dehumidifier: "--",
      humidityAllowedMaxB3Sensor1: "--",
      humidityAllowedMaxB3Sensor2: "--",
      humidityAllowedMaxB4Dehumidifier: "--",
      humidityAllowedMaxB4Sensor1: "--",
      humidityAllowedMaxB4Sensor2: "--",
      humidityAllowedMaxC1Dehumidifier: "--",
      humidityAllowedMaxC1Sensor1: "--",
      humidityAllowedMaxC1Sensor2: "--",
      humidityAllowedMaxC2Dehumidifier: "--",
      humidityAllowedMaxC2Sensor1: "--",
      humidityAllowedMaxC2Sensor2: "--",
      humidityAllowedMaxC3Dehumidifier: "--",
      humidityAllowedMaxC3Sensor1: "--",
      humidityAllowedMaxC3Sensor2: "--",
      humidityAllowedMaxC4Dehumidifier: "--",
      humidityAllowedMaxC4Sensor1: "--",
      humidityAllowedMaxC4Sensor2: "--",
      humidityAllowedMaxD1Dehumidifier: "--",
      humidityAllowedMaxD1Sensor1: "--",
      humidityAllowedMaxD1Sensor2: "--",
      humidityAllowedMaxD2Dehumidifier: "--",
      humidityAllowedMaxD2Sensor1: "--",
      humidityAllowedMaxD2Sensor2: "--",
      humidityAllowedMaxD3Dehumidifier: "--",
      humidityAllowedMaxD3Sensor1: "--",
      humidityAllowedMaxD3Sensor2: "--",
      humidityAllowedMaxD4Dehumidifier: "--",
      humidityAllowedMaxD4Sensor1: "--",
      humidityAllowedMaxD4Sensor2: "--",
      humidityAllowedMaxE1Dehumidifier: "--",
      humidityAllowedMaxE1Sensor1: "--",
      humidityAllowedMaxE1Sensor2: "--",
      humidityAllowedMaxE2Dehumidifier: "--",
      humidityAllowedMaxE2Sensor1: "--",
      humidityAllowedMaxE2Sensor2: "--",
      humidityAllowedMaxE3Dehumidifier: "--",
      humidityAllowedMaxE3Sensor1: "--",
      humidityAllowedMaxE3Sensor2: "--",
      humidityAllowedMaxE4Dehumidifier: "--",
      humidityAllowedMaxE4Sensor1: "--",
      humidityAllowedMaxE4Sensor2: "--",

      humidityA1Dehumidifier: "--",
      humidityA1Sensor1: "--",
      humidityA1Sensor2: "--",
      humidityA2Dehumidifier: "--",
      humidityA2Sensor1: "--",
      humidityA2Sensor2: "--",
      temperatureA1Dehumidifier: "--",
      temperatureA1Sensor1: "--",
      temperatureA1Sensor2: "--",
      temperatureA2Dehumidifier: "--",
      temperatureA2Sensor1: "--",
      temperatureA2Sensor2: "--",
      runningDehumidifierA1: "--",
      runningDehumidifierA2: "--",

      humidityB1Dehumidifier: "--",
      humidityB1Sensor1: "--",
      humidityB1Sensor2: "--",
      humidityB2Dehumidifier: "--",
      humidityB2Sensor1: "--",
      humidityB2Sensor2: "--",
      humidityB3Dehumidifier: "--",
      humidityB3Sensor1: "--",
      humidityB3Sensor2: "--",
      humidityB4Dehumidifier: "--",
      humidityB4Sensor1: "--",
      humidityB4Sensor2: "--",
      temperatureB1Dehumidifier: "--",
      temperatureB1Sensor1: "--",
      temperatureB1Sensor2: "--",
      temperatureB2Dehumidifier: "--",
      temperatureB2Sensor1: "--",
      temperatureB2Sensor2: "--",
      temperatureB3Dehumidifier: "--",
      temperatureB3Sensor1: "--",
      temperatureB3Sensor2: "--",
      temperatureB4Dehumidifier: "--",
      temperatureB4Sensor1: "--",
      temperatureB4Sensor2: "--",
      runningDehumidifierB1: "--",
      runningDehumidifierB2: "--",
      runningDehumidifierB3: "--",
      runningDehumidifierB4: "--",

      humidityC1Dehumidifier: "--",
      humidityC1Sensor1: "--",
      humidityC1Sensor2: "--",
      humidityC2Dehumidifier: "--",
      humidityC2Sensor1: "--",
      humidityC2Sensor2: "--",
      humidityC3Dehumidifier: "--",
      humidityC3Sensor1: "--",
      humidityC3Sensor2: "--",
      humidityC4Dehumidifier: "--",
      humidityC4Sensor1: "--",
      humidityC4Sensor2: "--",
      temperatureC1Dehumidifier: "--",
      temperatureC1Sensor1: "--",
      temperatureC1Sensor2: "--",
      temperatureC2Dehumidifier: "--",
      temperatureC2Sensor1: "--",
      temperatureC2Sensor2: "--",
      temperatureC3Dehumidifier: "--",
      temperatureC3Sensor1: "--",
      temperatureC3Sensor2: "--",
      temperatureC4Dehumidifier: "--",
      temperatureC4Sensor1: "--",
      temperatureC4Sensor2: "--",
      runningDehumidifierC1: "--",
      runningDehumidifierC2: "--",
      runningDehumidifierC3: "--",
      runningDehumidifierC4: "--",

      humidityD1Dehumidifier: "--",
      humidityD1Sensor1: "--",
      humidityD1Sensor2: "--",
      humidityD2Dehumidifier: "--",
      humidityD2Sensor1: "--",
      humidityD2Sensor2: "--",
      humidityD3Dehumidifier: "--",
      humidityD3Sensor1: "--",
      humidityD3Sensor2: "--",
      humidityD4Dehumidifier: "--",
      humidityD4Sensor1: "--",
      humidityD4Sensor2: "--",
      temperatureD1Dehumidifier: "--",
      temperatureD1Sensor1: "--",
      temperatureD1Sensor2: "--",
      temperatureD2Dehumidifier: "--",
      temperatureD2Sensor1: "--",
      temperatureD2Sensor2: "--",
      temperatureD3Dehumidifier: "--",
      temperatureD3Sensor1: "--",
      temperatureD3Sensor2: "--",
      temperatureD4Dehumidifier: "--",
      temperatureD4Sensor1: "--",
      temperatureD4Sensor2: "--",
      runningDehumidifierD1: "--",
      runningDehumidifierD2: "--",
      runningDehumidifierD3: "--",
      runningDehumidifierD4: "--",

      humidityE1Dehumidifier: "--",
      humidityE1Sensor1: "--",
      humidityE1Sensor2: "--",
      humidityE2Dehumidifier: "--",
      humidityE2Sensor1: "--",
      humidityE2Sensor2: "--",
      humidityE3Dehumidifier: "--",
      humidityE3Sensor1: "--",
      humidityE3Sensor2: "--",
      humidityE4Dehumidifier: "--",
      humidityE4Sensor1: "--",
      humidityE4Sensor2: "--",
      temperatureE1Dehumidifier: "--",
      temperatureE1Sensor1: "--",
      temperatureE1Sensor2: "--",
      temperatureE2Dehumidifier: "--",
      temperatureE2Sensor1: "--",
      temperatureE2Sensor2: "--",
      temperatureE3Dehumidifier: "--",
      temperatureE3Sensor1: "--",
      temperatureE3Sensor2: "--",
      temperatureE4Dehumidifier: "--",
      temperatureE4Sensor1: "--",
      temperatureE4Sensor2: "--",
      runningDehumidifierE1: "--",
      runningDehumidifierE2: "--",
      runningDehumidifierE3: "--",
      runningDehumidifierE4: "--",

      errorA1Dehumidifier: "",
      errorA1Sensor: "",
      errorA2Dehumidifier: "",
      errorA2Sensor: "",

      errorB1Dehumidifier: "",
      errorB1Sensor: "",
      errorB2Dehumidifier: "",
      errorB2Sensor: "",
      errorB3Dehumidifier: "",
      errorB3Sensor: "",
      errorB4Dehumidifier: "",
      errorB4Sensor: "",

      errorC1Dehumidifier: "",
      errorC1Sensor: "",
      errorC2Dehumidifier: "",
      errorC2Sensor: "",
      errorC3Dehumidifier: "",
      errorC3Sensor: "",
      errorC4Dehumidifier: "",
      errorC4Sensor: "",

      errorD1Dehumidifier: "",
      errorD1Sensor: "",
      errorD2Dehumidifier: "",
      errorD2Sensor: "",
      errorD3Dehumidifier: "",
      errorD3Sensor: "",
      errorD4Dehumidifier: "",
      errorD4Sensor: "",

      errorE1Dehumidifier: "",
      errorE1Sensor: "",
      errorE2Dehumidifier: "",
      errorE2Sensor: "",
      errorE3Dehumidifier: "",
      errorE3Sensor: "",
      errorE4Dehumidifier: "",
      errorE4Sensor: "",

      // runningTooltipA1: "--",
      // runningTooltipA2: "--",
      // runningTooltipB1: "--",
      // runningTooltipB2: "--",
      // runningTooltipB3: "--",
      // runningTooltipB4: "--",
      // runningTooltipC1: "--",
      // runningTooltipC2: "--",
      // runningTooltipC3: "--",
      // runningTooltipC4: "--",
      // runningTooltipD1: "--",
      // runningTooltipD2: "--",
      // runningTooltipD3: "--",
      // runningTooltipD4: "--",
      // runningTooltipE1: "--",
      // runningTooltipE2: "--",
      // runningTooltipE3: "--",
      // runningTooltipE4: "--",

      runningClassA1: "",
      runningClassA2: "",
      runningClassB1: "",
      runningClassB2: "",
      runningClassB3: "",
      runningClassB4: "",
      runningClassC1: "",
      runningClassC2: "",
      runningClassC3: "",
      runningClassC4: "",
      runningClassD1: "",
      runningClassD2: "",
      runningClassD3: "",
      runningClassD4: "",
      runningClassE1: "",
      runningClassE2: "",
      runningClassE3: "",
      runningClassE4: "",

      dataNameIdDict: {
        humidityA1Dehumidifier: "d33d6a40-71ab-414d-8d2d-28298ee59f3b",
        humidityA1Sensor1: "b1f70aa8-a03e-4a90-8ee9-2ef58f6ed057",
        humidityA1Sensor2: "49ad266d-980a-4d9a-a595-709e0450514d",
        humidityA2Dehumidifier: "42602ce0-d27f-4836-b4e2-285e9b7385e9",
        humidityA2Sensor1: "8984e9eb-915b-4cfb-a06e-7b71476a3b36",
        humidityA2Sensor2: "cc533a9b-002d-4db6-8c76-8602bf112204",
        temperatureA1Dehumidifier: "ce0304e2-2f2c-4bc5-b77a-f525ce492848",
        temperatureA1Sensor1: "b6ef2bc8-aefd-4002-9392-373cbfc0f58f",
        temperatureA1Sensor2: "1b5a22b5-215a-451b-9e59-88396d36e99b",
        temperatureA2Dehumidifier: "b04755cd-ae89-47bd-8685-3be8c3aa4e67",
        temperatureA2Sensor1: "8ffaed6d-a456-461f-b417-e2e33dc680f2",
        temperatureA2Sensor2: "3a6fc513-3dc0-40b3-a9fc-fa2d35eac167",
        runningDehumidifierA1: "00157a46-2264-4c52-b5bd-d089071463cc",
        runningDehumidifierA2: "f5816e88-6a27-48b0-a8af-fd8f42ea163b",

        humidityB1Dehumidifier: "5e935480-9a42-40cf-bbd9-afff52ce4300",
        humidityB1Sensor1: "24bb0f37-e320-4073-834f-bf04110ff376",
        humidityB1Sensor2: "f0727238-986a-49fd-888f-a6c16d92b001",
        humidityB2Dehumidifier: "72f2baa6-9325-437f-baf5-cac44d444225",
        humidityB2Sensor1: "9a5c5e3d-c324-4270-a680-4a83e72edd68",
        humidityB2Sensor2: "0c721e5f-9e3f-4b8c-afc8-abce5d1d1c81",
        humidityB3Dehumidifier: "67560bf2-5060-4728-a2c7-b2f17bd3dc16",
        humidityB3Sensor1: "8d02f746-3f44-484a-9672-9b3627cfe4b3",
        humidityB3Sensor2: "e8471086-62c6-49fe-a27f-8dc3d4ee0e25",
        humidityB4Dehumidifier: "4dc80278-657d-404f-a449-f27fe5235862",
        humidityB4Sensor1: "cb274aad-ece9-4489-9f10-62f01d201b1d",
        humidityB4Sensor2: "fcaebef7-1b4a-4528-966d-085f870d174e",
        temperatureB1Dehumidifier: "2d617cf7-e2d8-4346-a415-33af5e607721",
        temperatureB1Sensor1: "43b49388-f947-4290-872b-35d3b8926cf5",
        temperatureB1Sensor2: "4a441140-0e07-4325-bbcd-9a5c3540d7fa",
        temperatureB2Dehumidifier: "921b5c6a-29d4-4e7a-96a8-915b1dd80b53",
        temperatureB2Sensor1: "5bc8272a-5a38-4b5f-b3bf-ffd753eab942",
        temperatureB2Sensor2: "07e10e3d-f8e6-4d50-b587-b365382b7bd6",
        temperatureB3Dehumidifier: "49efbcca-fc21-4e31-9431-be191ff6337a",
        temperatureB3Sensor1: "d3bae6b9-796a-4b7b-8000-0a0e5c1737cc",
        temperatureB3Sensor2: "9b5f3e77-ab2e-43b3-86f1-74c4fc299474",
        temperatureB4Dehumidifier: "81f2b2d1-620b-435e-98ba-aa4fcd7c47f3",
        temperatureB4Sensor1: "2cb0eba8-09e6-4117-b63a-7a4bd6606eff",
        temperatureB4Sensor2: "19e6c626-cefc-4201-9a3d-106f066e0d03",
        runningDehumidifierB1: "cc79e314-8bfb-4153-a1a6-68647fdad33f",
        runningDehumidifierB2: "b28c63f2-9616-4755-93e0-cb0304bc83c1",
        runningDehumidifierB3: "f78a9420-3be4-4a9d-9bae-aa3000075aea",
        runningDehumidifierB4: "ac8c684b-ca06-4916-9481-bfe5cf15ff26",

        humidityC1Dehumidifier: "5d05229b-ed6a-44d4-8d3b-d9d6f2e6dbb9",
        humidityC1Sensor1: "ff78c149-9c7d-4061-b5cb-5c80dc966d94",
        humidityC1Sensor2: "8586c00d-4502-4509-a2fd-11634427ff4d",
        humidityC2Dehumidifier: "cc2abb4e-b078-44a9-8766-672608c85f4e",
        humidityC2Sensor1: "f1bebf3f-895e-4938-9f0f-84839c1b2abf",
        humidityC2Sensor2: "7c11db35-4beb-4b37-b3ed-4bfb3d1bf1fb",
        humidityC3Dehumidifier: "3596893e-47b3-4530-9281-780d03ce64dd",
        humidityC3Sensor1: "439c77d1-8e50-4321-85dd-6c67126cabe0",
        humidityC3Sensor2: "667bf3d5-dde1-4ed9-a68a-693d367d1744",
        humidityC4Dehumidifier: "2c16547a-c00b-4920-a086-218fb5746323",
        humidityC4Sensor1: "40dd46d2-35a6-430b-a797-f4025c0c7f97",
        humidityC4Sensor2: "9d9585e7-a259-4477-9a2a-3eb9edb9f217",
        temperatureC1Dehumidifier: "b4f4cc77-f804-4a9d-a9a9-e2b10310fb14",
        temperatureC1Sensor1: "4604ca6f-7ecd-4612-9aa9-6f5cf165a5bf",
        temperatureC1Sensor2: "893499f4-db97-42d0-9c5b-d632dc8615c8",
        temperatureC2Dehumidifier: "c0772a77-8ce8-484b-b083-6a32c3e62048",
        temperatureC2Sensor1: "6516ff4e-d6e3-4bc1-be68-beeeb4f93a04",
        temperatureC2Sensor2: "ad56893b-e664-44a1-8552-c812b115224b",
        temperatureC3Dehumidifier: "8dd6a9ae-0d9b-47e2-84fb-0b4c425af07d",
        temperatureC3Sensor1: "97e3e4de-83b8-485e-a21e-06a5190bf11d",
        temperatureC3Sensor2: "1ac43afe-275b-4693-aa2b-ac9825c21e12",
        temperatureC4Dehumidifier: "2eb94745-c0cf-4370-9e7f-e0e82530e99b",
        temperatureC4Sensor1: "66f9f2de-81bd-411b-82e0-a8a69d27a268",
        temperatureC4Sensor2: "ca9c42f9-f68e-431b-8f5b-c7ccee4b4909",
        runningDehumidifierC1: "f0f19043-39e4-4d65-b82c-7ff6de75689e",
        runningDehumidifierC2: "d55d3739-c264-4f2f-b661-342b47c7062b",
        runningDehumidifierC3: "ec286d82-8c76-4ab1-831e-b110cfc76aef",
        runningDehumidifierC4: "e8a0c0f5-c402-4dac-b8b1-140b8688e6e9",

        humidityD1Dehumidifier: "1349438b-ae62-4272-aece-483909f9d518",
        humidityD1Sensor1: "47677b32-6f0a-48d4-8df8-3de2785c0946",
        humidityD1Sensor2: "3d246a70-829f-4175-88f6-f542411fe4a7",
        humidityD2Dehumidifier: "51fa23af-5d39-43e1-b2ff-f29d95f1d9e3",
        humidityD2Sensor1: "e9c7faaa-5727-4cae-a6f7-a78bba568d89",
        humidityD2Sensor2: "c83a7055-2e1b-4d0c-8150-cc09c046c059",
        humidityD3Dehumidifier: "2a02f4e9-e8ee-4e96-8eee-7180b189373d",
        humidityD3Sensor1: "e9c7c65c-1853-4ead-8199-5a121d36a2d2",
        humidityD3Sensor2: "4fa43a5a-5033-46e8-8bf1-2c4b476717af",
        humidityD4Dehumidifier: "b7086468-75e3-4fee-905c-61a6457902cd",
        humidityD4Sensor1: "347d76c9-ab90-4c56-a403-e583b294c46d",
        humidityD4Sensor2: "7b38f0f5-0d4a-4c04-8c8c-8a09f0921d5d",
        temperatureD1Dehumidifier: "11920608-5cea-413b-b0e2-f8d45581d994",
        temperatureD1Sensor1: "14a6a14d-8fef-4fe8-b0bd-8f4631f3d130",
        temperatureD1Sensor2: "f21df9ed-e222-4568-aa62-c9daeb1017c2",
        temperatureD2Dehumidifier: "2c5da5c8-c2a8-4733-a233-731a373c9784",
        temperatureD2Sensor1: "c5841a6a-dd1e-4dfc-a3c3-b12a0ba6ff85",
        temperatureD2Sensor2: "4a62c359-a2c8-42e5-9a6d-6c58e937f5ce",
        temperatureD3Dehumidifier: "59c71f74-e33a-4f31-8b60-377041197947",
        temperatureD3Sensor1: "d1e9ac4b-79eb-4a74-aeec-6838a4b3091b",
        temperatureD3Sensor2: "3c8ac423-37bd-48ae-8d59-06c8722586f7",
        temperatureD4Dehumidifier: "12cbf79e-cf4e-49c1-88b8-2e5a13d0ad41",
        temperatureD4Sensor1: "b852f5b1-ae3f-428c-a1bb-ed6581e5612e",
        temperatureD4Sensor2: "86c9d2b7-8776-4d8d-adf3-a21eee4c5cfd",
        runningDehumidifierD1: "ab93f000-699a-4201-856d-331407850ed4",
        runningDehumidifierD2: "ad771d06-ea4e-42b4-90fe-2e1caf724891",
        runningDehumidifierD3: "8de4958b-aca3-47f0-86e3-4bf113d6c28c",
        runningDehumidifierD4: "3b5d359b-1c28-4867-9832-77718e671ed3",

        humidityE1Dehumidifier: "f43831d7-0639-4989-ad9b-a971f21db9d6",
        humidityE1Sensor1: "9d369969-1cc6-4818-9a14-bc166466b4bc",
        humidityE1Sensor2: "e580e612-ddc8-4c81-8b77-216257b995df",
        humidityE2Dehumidifier: "6b844617-c7a9-4416-82ba-d3cf354e7288",
        humidityE2Sensor1: "130bb004-8f31-4d61-aff0-1beb9a6a4034",
        humidityE2Sensor2: "897595f8-ce25-4622-9334-3ea5e0f7a292",
        humidityE3Dehumidifier: "3d5ab3bb-1812-4395-ad83-98f1bd8fd1c1",
        humidityE3Sensor1: "46814df9-5891-4acb-be10-9c774864a3c3",
        humidityE3Sensor2: "054eea0f-c063-4675-ba33-854241ffa515",
        humidityE4Dehumidifier: "2d418ea2-969c-405c-b9ae-64130f9b3520",
        humidityE4Sensor1: "090356d9-489b-4191-bd65-b4e5611160a5",
        humidityE4Sensor2: "b926d126-eb42-45cc-8ee1-64dd5d45019d",
        temperatureE1Dehumidifier: "c9d2e623-9236-4432-9154-9b347b4dd34e",
        temperatureE1Sensor1: "a93ffc4f-748e-4cc2-a4dd-e7922ea98bd8",
        temperatureE1Sensor2: "33ca45f0-2407-44e3-89af-b5a461c5154c",
        temperatureE2Dehumidifier: "c269e100-c7a5-46fb-86e5-bacf404edb14",
        temperatureE2Sensor1: "5d5a2ebd-c701-4b9a-944f-53c4e60fe7e2",
        temperatureE2Sensor2: "953bcf1f-e7a6-4e80-8e18-a8514ecf77fb",
        temperatureE3Dehumidifier: "3cdc503c-2994-461c-948b-43253cdff02e",
        temperatureE3Sensor1: "67c5f400-1f69-4f4e-a68e-aacb5a90b758",
        temperatureE3Sensor2: "901abe0d-62c5-482e-8526-430c728054e4",
        temperatureE4Dehumidifier: "733a8dff-7d8e-4bc8-a01d-14e254146425",
        temperatureE4Sensor1: "555a46f9-246a-4eb4-874d-3c772f57c16c",
        temperatureE4Sensor2: "9f13103f-b4b4-472b-b5e7-7d8214903dd4",
        runningDehumidifierE1: "497eb841-0aa0-4503-8704-2cd0b6d1cde4",
        runningDehumidifierE2: "a216de37-a9bc-49a6-b46b-98b38698b88c",
        runningDehumidifierE3: "fb6aff8e-c5a4-4b81-8bb8-eae201a2b7a6",
        runningDehumidifierE4: "5758fce1-04f9-4b55-93cc-0a963e4e3d34",
      },
      allowedMaxNameIdDict: {
        humidityAllowedMaxA1Dehumidifier: "d33d6a40-71ab-414d-8d2d-28298ee59f3b",
        humidityAllowedMaxA1Sensor1: "b1f70aa8-a03e-4a90-8ee9-2ef58f6ed057",
        humidityAllowedMaxA1Sensor2: "49ad266d-980a-4d9a-a595-709e0450514d",
        humidityAllowedMaxA2Dehumidifier: "42602ce0-d27f-4836-b4e2-285e9b7385e9",
        humidityAllowedMaxA2Sensor1: "8984e9eb-915b-4cfb-a06e-7b71476a3b36",
        humidityAllowedMaxA2Sensor2: "cc533a9b-002d-4db6-8c76-8602bf112204",
        humidityAllowedMaxB1Dehumidifier: "5e935480-9a42-40cf-bbd9-afff52ce4300",
        humidityAllowedMaxB1Sensor1: "24bb0f37-e320-4073-834f-bf04110ff376",
        humidityAllowedMaxB1Sensor2: "f0727238-986a-49fd-888f-a6c16d92b001",
        humidityAllowedMaxB2Dehumidifier: "72f2baa6-9325-437f-baf5-cac44d444225",
        humidityAllowedMaxB2Sensor1: "9a5c5e3d-c324-4270-a680-4a83e72edd68",
        humidityAllowedMaxB2Sensor2: "0c721e5f-9e3f-4b8c-afc8-abce5d1d1c81",
        humidityAllowedMaxB3Dehumidifier: "67560bf2-5060-4728-a2c7-b2f17bd3dc16",
        humidityAllowedMaxB3Sensor1: "8d02f746-3f44-484a-9672-9b3627cfe4b3",
        humidityAllowedMaxB3Sensor2: "e8471086-62c6-49fe-a27f-8dc3d4ee0e25",
        humidityAllowedMaxB4Dehumidifier: "4dc80278-657d-404f-a449-f27fe5235862",
        humidityAllowedMaxB4Sensor1: "cb274aad-ece9-4489-9f10-62f01d201b1d",
        humidityAllowedMaxB4Sensor2: "fcaebef7-1b4a-4528-966d-085f870d174e",
        humidityAllowedMaxC1Dehumidifier: "5d05229b-ed6a-44d4-8d3b-d9d6f2e6dbb9",
        humidityAllowedMaxC1Sensor1: "ff78c149-9c7d-4061-b5cb-5c80dc966d94",
        humidityAllowedMaxC1Sensor2: "8586c00d-4502-4509-a2fd-11634427ff4d",
        humidityAllowedMaxC2Dehumidifier: "cc2abb4e-b078-44a9-8766-672608c85f4e",
        humidityAllowedMaxC2Sensor1: "f1bebf3f-895e-4938-9f0f-84839c1b2abf",
        humidityAllowedMaxC2Sensor2: "7c11db35-4beb-4b37-b3ed-4bfb3d1bf1fb",
        humidityAllowedMaxC3Dehumidifier: "3596893e-47b3-4530-9281-780d03ce64dd",
        humidityAllowedMaxC3Sensor1: "439c77d1-8e50-4321-85dd-6c67126cabe0",
        humidityAllowedMaxC3Sensor2: "667bf3d5-dde1-4ed9-a68a-693d367d1744",
        humidityAllowedMaxC4Dehumidifier: "2c16547a-c00b-4920-a086-218fb5746323",
        humidityAllowedMaxC4Sensor1: "40dd46d2-35a6-430b-a797-f4025c0c7f97",
        humidityAllowedMaxC4Sensor2: "9d9585e7-a259-4477-9a2a-3eb9edb9f217",
        humidityAllowedMaxD1Dehumidifier: "1349438b-ae62-4272-aece-483909f9d518",
        humidityAllowedMaxD1Sensor1: "47677b32-6f0a-48d4-8df8-3de2785c0946",
        humidityAllowedMaxD1Sensor2: "3d246a70-829f-4175-88f6-f542411fe4a7",
        humidityAllowedMaxD2Dehumidifier: "51fa23af-5d39-43e1-b2ff-f29d95f1d9e3",
        humidityAllowedMaxD2Sensor1: "e9c7faaa-5727-4cae-a6f7-a78bba568d89",
        humidityAllowedMaxD2Sensor2: "c83a7055-2e1b-4d0c-8150-cc09c046c059",
        humidityAllowedMaxD3Dehumidifier: "2a02f4e9-e8ee-4e96-8eee-7180b189373d",
        humidityAllowedMaxD3Sensor1: "e9c7c65c-1853-4ead-8199-5a121d36a2d2",
        humidityAllowedMaxD3Sensor2: "4fa43a5a-5033-46e8-8bf1-2c4b476717af",
        humidityAllowedMaxD4Dehumidifier: "b7086468-75e3-4fee-905c-61a6457902cd",
        humidityAllowedMaxD4Sensor1: "347d76c9-ab90-4c56-a403-e583b294c46d",
        humidityAllowedMaxD4Sensor2: "7b38f0f5-0d4a-4c04-8c8c-8a09f0921d5d",
        humidityAllowedMaxE1Dehumidifier: "f43831d7-0639-4989-ad9b-a971f21db9d6",
        humidityAllowedMaxE1Sensor1: "9d369969-1cc6-4818-9a14-bc166466b4bc",
        humidityAllowedMaxE1Sensor2: "e580e612-ddc8-4c81-8b77-216257b995df",
        humidityAllowedMaxE2Dehumidifier: "6b844617-c7a9-4416-82ba-d3cf354e7288",
        humidityAllowedMaxE2Sensor1: "130bb004-8f31-4d61-aff0-1beb9a6a4034",
        humidityAllowedMaxE2Sensor2: "897595f8-ce25-4622-9334-3ea5e0f7a292",
        humidityAllowedMaxE3Dehumidifier: "3d5ab3bb-1812-4395-ad83-98f1bd8fd1c1",
        humidityAllowedMaxE3Sensor1: "46814df9-5891-4acb-be10-9c774864a3c3",
        humidityAllowedMaxE3Sensor2: "054eea0f-c063-4675-ba33-854241ffa515",
        humidityAllowedMaxE4Dehumidifier: "2d418ea2-969c-405c-b9ae-64130f9b3520",
        humidityAllowedMaxE4Sensor1: "090356d9-489b-4191-bd65-b4e5611160a5",
        humidityAllowedMaxE4Sensor2: "b926d126-eb42-45cc-8ee1-64dd5d45019d",
      },
      dataNameErrorNameDict: {
        humidityA1Dehumidifier: "errorA1Dehumidifier",
        humidityA1Sensor1: "errorA1Sensor",
        humidityA1Sensor2: "errorA1Sensor",
        humidityA2Dehumidifier: "errorA2Dehumidifier",
        humidityA2Sensor1: "errorA2Sensor",
        humidityA2Sensor2: "errorA2Sensor",
        temperatureA1Dehumidifier: "errorA1Dehumidifier",
        temperatureA1Sensor1: "errorA1Sensor",
        temperatureA1Sensor2: "errorA1Sensor",
        temperatureA2Dehumidifier: "errorA2Dehumidifier",
        temperatureA2Sensor1: "errorA2Sensor",
        temperatureA2Sensor2: "errorA2Sensor",

        humidityB1Dehumidifier: "errorB1Dehumidifier",
        humidityB1Sensor1: "errorB1Sensor",
        humidityB1Sensor2: "errorB1Sensor",
        humidityB2Dehumidifier: "errorB2Dehumidifier",
        humidityB2Sensor1: "errorB2Sensor",
        humidityB2Sensor2: "errorB2Sensor",
        humidityB3Dehumidifier: "errorB3Dehumidifier",
        humidityB3Sensor1: "errorB3Sensor",
        humidityB3Sensor2: "errorB3Sensor",
        humidityB4Dehumidifier: "errorB4Dehumidifier",
        humidityB4Sensor1: "errorB4Sensor",
        humidityB4Sensor2: "errorB4Sensor",
        temperatureB1Dehumidifier: "errorB1Dehumidifier",
        temperatureB1Sensor1: "errorB1Sensor",
        temperatureB1Sensor2: "errorB1Sensor",
        temperatureB2Dehumidifier: "errorB2Dehumidifier",
        temperatureB2Sensor1: "errorB2Sensor",
        temperatureB2Sensor2: "errorB2Sensor",
        temperatureB3Dehumidifier: "errorB3Dehumidifier",
        temperatureB3Sensor1: "errorB3Sensor",
        temperatureB3Sensor2: "errorB3Sensor",
        temperatureB4Dehumidifier: "errorB4Dehumidifier",
        temperatureB4Sensor1: "errorB4Sensor",
        temperatureB4Sensor2: "errorB4Sensor",

        humidityC1Dehumidifier: "errorC1Dehumidifier",
        humidityC1Sensor1: "errorC1Sensor",
        humidityC1Sensor2: "errorC1Sensor",
        humidityC2Dehumidifier: "errorC2Dehumidifier",
        humidityC2Sensor1: "errorC2Sensor",
        humidityC2Sensor2: "errorC2Sensor",
        humidityC3Dehumidifier: "errorC3Dehumidifier",
        humidityC3Sensor1: "errorC3Sensor",
        humidityC3Sensor2: "errorC3Sensor",
        humidityC4Dehumidifier: "errorC4Dehumidifier",
        humidityC4Sensor1: "errorC4Sensor",
        humidityC4Sensor2: "errorC4Sensor",
        temperatureC1Dehumidifier: "errorC1Dehumidifier",
        temperatureC1Sensor1: "errorC1Sensor",
        temperatureC1Sensor2: "errorC1Sensor",
        temperatureC2Dehumidifier: "errorC2Dehumidifier",
        temperatureC2Sensor1: "errorC2Sensor",
        temperatureC2Sensor2: "errorC2Sensor",
        temperatureC3Dehumidifier: "errorC3Dehumidifier",
        temperatureC3Sensor1: "errorC3Sensor",
        temperatureC3Sensor2: "errorC3Sensor",
        temperatureC4Dehumidifier: "errorC4Dehumidifier",
        temperatureC4Sensor1: "errorC4Sensor",
        temperatureC4Sensor2: "errorC4Sensor",

        humidityD1Dehumidifier: "errorD1Dehumidifier",
        humidityD1Sensor1: "errorD1Sensor",
        humidityD1Sensor2: "errorD1Sensor",
        humidityD2Dehumidifier: "errorD2Dehumidifier",
        humidityD2Sensor1: "errorD2Sensor",
        humidityD2Sensor2: "errorD2Sensor",
        humidityD3Dehumidifier: "errorD3Dehumidifier",
        humidityD3Sensor1: "errorD3Sensor",
        humidityD3Sensor2: "errorD3Sensor",
        humidityD4Dehumidifier: "errorD4Dehumidifier",
        humidityD4Sensor1: "errorD4Sensor",
        humidityD4Sensor2: "errorD4Sensor",
        temperatureD1Dehumidifier: "errorD1Dehumidifier",
        temperatureD1Sensor1: "errorD1Sensor",
        temperatureD1Sensor2: "errorD1Sensor",
        temperatureD2Dehumidifier: "errorD2Dehumidifier",
        temperatureD2Sensor1: "errorD2Sensor",
        temperatureD2Sensor2: "errorD2Sensor",
        temperatureD3Dehumidifier: "errorD3Dehumidifier",
        temperatureD3Sensor1: "errorD3Sensor",
        temperatureD3Sensor2: "errorD3Sensor",
        temperatureD4Dehumidifier: "errorD4Dehumidifier",
        temperatureD4Sensor1: "errorD4Sensor",
        temperatureD4Sensor2: "errorD4Sensor",

        humidityE1Dehumidifier: "errorE1Dehumidifier",
        humidityE1Sensor1: "errorE1Sensor",
        humidityE1Sensor2: "errorE1Sensor",
        humidityE2Dehumidifier: "errorE2Dehumidifier",
        humidityE2Sensor1: "errorE2Sensor",
        humidityE2Sensor2: "errorE2Sensor",
        humidityE3Dehumidifier: "errorE3Dehumidifier",
        humidityE3Sensor1: "errorE3Sensor",
        humidityE3Sensor2: "errorE3Sensor",
        humidityE4Dehumidifier: "errorE4Dehumidifier",
        humidityE4Sensor1: "errorE4Sensor",
        humidityE4Sensor2: "errorE4Sensor",
        temperatureE1Dehumidifier: "errorE1Dehumidifier",
        temperatureE1Sensor1: "errorE1Sensor",
        temperatureE1Sensor2: "errorE1Sensor",
        temperatureE2Dehumidifier: "errorE2Dehumidifier",
        temperatureE2Sensor1: "errorE2Sensor",
        temperatureE2Sensor2: "errorE2Sensor",
        temperatureE3Dehumidifier: "errorE3Dehumidifier",
        temperatureE3Sensor1: "errorE3Sensor",
        temperatureE3Sensor2: "errorE3Sensor",
        temperatureE4Dehumidifier: "errorE4Dehumidifier",
        temperatureE4Sensor1: "errorE4Sensor",
        temperatureE4Sensor2: "errorE4Sensor",
      },
      malfunctionDataNameErrorNameDict: {},
      dataNameTooltipErrorNameDict: {
        humidityA1Dehumidifier: "humidityTooltipErrorA1Dehumidifier",
        humidityA1Sensor1: "humidityTooltipErrorA1Sensor1",
        humidityA1Sensor2: "humidityTooltipErrorA1Sensor2",
        humidityA2Dehumidifier: "humidityTooltipErrorA2Dehumidifier",
        humidityA2Sensor1: "humidityTooltipErrorA2Sensor1",
        humidityA2Sensor2: "humidityTooltipErrorA2Sensor2",
        humidityB1Dehumidifier: "humidityTooltipErrorB1Dehumidifier",
        humidityB1Sensor1: "humidityTooltipErrorB1Sensor1",
        humidityB1Sensor2: "humidityTooltipErrorB1Sensor2",
        humidityB2Dehumidifier: "humidityTooltipErrorB2Dehumidifier",
        humidityB2Sensor1: "humidityTooltipErrorB2Sensor1",
        humidityB2Sensor2: "humidityTooltipErrorB2Sensor2",
        humidityB3Dehumidifier: "humidityTooltipErrorB3Dehumidifier",
        humidityB3Sensor1: "humidityTooltipErrorB3Sensor1",
        humidityB3Sensor2: "humidityTooltipErrorB3Sensor2",
        humidityB4Dehumidifier: "humidityTooltipErrorB4Dehumidifier",
        humidityB4Sensor1: "humidityTooltipErrorB4Sensor1",
        humidityB4Sensor2: "humidityTooltipErrorB4Sensor2",
        humidityC1Dehumidifier: "humidityTooltipErrorC1Dehumidifier",
        humidityC1Sensor1: "humidityTooltipErrorC1Sensor1",
        humidityC1Sensor2: "humidityTooltipErrorC1Sensor2",
        humidityC2Dehumidifier: "humidityTooltipErrorC2Dehumidifier",
        humidityC2Sensor1: "humidityTooltipErrorC2Sensor1",
        humidityC2Sensor2: "humidityTooltipErrorC2Sensor2",
        humidityC3Dehumidifier: "humidityTooltipErrorC3Dehumidifier",
        humidityC3Sensor1: "humidityTooltipErrorC3Sensor1",
        humidityC3Sensor2: "humidityTooltipErrorC3Sensor2",
        humidityC4Dehumidifier: "humidityTooltipErrorC4Dehumidifier",
        humidityC4Sensor1: "humidityTooltipErrorC4Sensor1",
        humidityC4Sensor2: "humidityTooltipErrorC4Sensor2",
        humidityD1Dehumidifier: "humidityTooltipErrorD1Dehumidifier",
        humidityD1Sensor1: "humidityTooltipErrorD1Sensor1",
        humidityD1Sensor2: "humidityTooltipErrorD1Sensor2",
        humidityD2Dehumidifier: "humidityTooltipErrorD2Dehumidifier",
        humidityD2Sensor1: "humidityTooltipErrorD2Sensor1",
        humidityD2Sensor2: "humidityTooltipErrorD2Sensor2",
        humidityD3Dehumidifier: "humidityTooltipErrorD3Dehumidifier",
        humidityD3Sensor1: "humidityTooltipErrorD3Sensor1",
        humidityD3Sensor2: "humidityTooltipErrorD3Sensor2",
        humidityD4Dehumidifier: "humidityTooltipErrorD4Dehumidifier",
        humidityD4Sensor1: "humidityTooltipErrorD4Sensor1",
        humidityD4Sensor2: "humidityTooltipErrorD4Sensor2",
        humidityE1Dehumidifier: "humidityTooltipErrorE1Dehumidifier",
        humidityE1Sensor1: "humidityTooltipErrorE1Sensor1",
        humidityE1Sensor2: "humidityTooltipErrorE1Sensor2",
        humidityE2Dehumidifier: "humidityTooltipErrorE2Dehumidifier",
        humidityE2Sensor1: "humidityTooltipErrorE2Sensor1",
        humidityE2Sensor2: "humidityTooltipErrorE2Sensor2",
        humidityE3Dehumidifier: "humidityTooltipErrorE3Dehumidifier",
        humidityE3Sensor1: "humidityTooltipErrorE3Sensor1",
        humidityE3Sensor2: "humidityTooltipErrorE3Sensor2",
        humidityE4Dehumidifier: "humidityTooltipErrorE4Dehumidifier",
        humidityE4Sensor1: "humidityTooltipErrorE4Sensor1",
        humidityE4Sensor2: "humidityTooltipErrorE4Sensor2",
      },
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierA1: "runningTooltipA1",
      //   runningDehumidifierA2: "runningTooltipA2",

      //   runningDehumidifierB1: "runningTooltipB1",
      //   runningDehumidifierB2: "runningTooltipB2",
      //   runningDehumidifierB3: "runningTooltipB3",
      //   runningDehumidifierB4: "runningTooltipB4",

      //   runningDehumidifierC1: "runningTooltipC1",
      //   runningDehumidifierC2: "runningTooltipC2",
      //   runningDehumidifierC3: "runningTooltipC3",
      //   runningDehumidifierC4: "runningTooltipC4",

      //   runningDehumidifierD1: "runningTooltipD1",
      //   runningDehumidifierD2: "runningTooltipD2",
      //   runningDehumidifierD3: "runningTooltipD3",
      //   runningDehumidifierD4: "runningTooltipD4",

      //   runningDehumidifierE1: "runningTooltipE1",
      //   runningDehumidifierE2: "runningTooltipE2",
      //   runningDehumidifierE3: "runningTooltipE3",
      //   runningDehumidifierE4: "runningTooltipE4",
      // },
      dataNameRunningClassNameDict: {
        runningDehumidifierA1: "runningClassA1",
        runningDehumidifierA2: "runningClassA2",

        runningDehumidifierB1: "runningClassB1",
        runningDehumidifierB2: "runningClassB2",
        runningDehumidifierB3: "runningClassB3",
        runningDehumidifierB4: "runningClassB4",

        runningDehumidifierC1: "runningClassC1",
        runningDehumidifierC2: "runningClassC2",
        runningDehumidifierC3: "runningClassC3",
        runningDehumidifierC4: "runningClassC4",

        runningDehumidifierD1: "runningClassD1",
        runningDehumidifierD2: "runningClassD2",
        runningDehumidifierD3: "runningClassD3",
        runningDehumidifierD4: "runningClassD4",

        runningDehumidifierE1: "runningClassE1",
        runningDehumidifierE2: "runningClassE2",
        runningDehumidifierE3: "runningClassE3",
        runningDehumidifierE4: "runningClassE4",
      },
      stationIdList: ["b1f625cc-77a0-4b1c-b4f7-4b8b0db6246e", "3a2cc68c-15a4-4427-a5f0-c7e978d61539"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (runningFlag > 0) {
        result += ", 除湿机运行";
      } else if (runningFlag === 0) {
        result += ", 除湿机停止";
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .left-dir-upchart {
        left: 200px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .right-dir-upchart {
        flex-direction: row-reverse;
        right: 180px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 320px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-a1 {
          top: 30px;
          left: 612px;
        }

        .station-block-a2 {
          top: 190px;
          left: 611px;
        }

        .station-block-d1 {
          top: 108px;
          left: 665px;
        }

        .station-block-d2 {
          top: 120px;
          left: 690px;
        }

        .station-block-d3 {
          top: 135px;
          left: 1005px;
        }

        .station-block-d4 {
          top: 135px;
          left: 1045px;
        }

        .station-block-e1 {
          top: 108px;
          left: 561px;
        }

        .station-block-e2 {
          top: 120px;
          left: 533px;
        }

        .station-block-e3 {
          top: 135px;
          left: 225px;
        }

        .station-block-e4 {
          top: 135px;
          left: 185px;
        }

        .station-block-b1 {
          top: 258px;
          left: 670px;
        }

        .station-block-b2 {
          top: 264px;
          left: 700px;
        }

        .station-block-b3 {
          top: 185px;
          left: 1005px;
        }

        .station-block-b4 {
          top: 186px;
          left: 1045px;
        }

        .station-block-c1 {
          top: 258px;
          left: 557px;
        }

        .station-block-c2 {
          top: 264px;
          left: 535px;
        }

        .station-block-c3 {
          top: 187px;
          left: 225px;
        }

        .station-block-c4 {
          top: 186px;
          left: 185px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            // cursor: pointer;
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-a1 {
          top: 10px;
          left: 827px;
          &::before {
            top: 18px;
            left: -241px;
            transform: rotate(36deg);
            width: 42px;
          }
          &:after {
            top: 6px;
            left: -252px;
          }
          .state-info {
            left: -382px;
            top: 8px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-a2 {
          top: 210px;
          left: 825px;
          &::before {
            top: -20px;
            left: -205px;
            transform: rotate(135deg);
            width: 25px;
          }
          &:after {
            top: -29px;
            left: -184px;
          }
          .state-info {
            left: -168px;
            top: -28px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-d1 {
          top: 135px;
          left: 875px;
          &::before {
            top: -30px;
            left: -205px;
            transform: rotate(135deg);
            width: 45px;
          }
          &:after {
            top: -46px;
            left: -168px;
          }
          .state-info {
            left: -152px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-d2 {
          top: 140px;
          left: 902px;
          &::before {
            top: -29px;
            left: -210px;
            transform: rotate(110deg);
            width: 40px;
          }
          &:after {
            top: -47px;
            left: -184px;
          }
          .state-info {
            left: -168px;
            top: -46px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-d3 {
          top: 150px;
          left: 1210px;
          &::before {
            top: -29px;
            left: -203px;
            transform: rotate(125deg);
            width: 55px;
          }
          &:after {
            top: -52px;
            left: -160px;
          }
          .state-info {
            left: -144px;
            top: -51px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-d4 {
          top: 150px;
          left: 1248px;
          &::before {
            top: -59px;
            left: -246px;
            transform: rotate(95deg);
            width: 120px;
          }
          &:after {
            top: -119px;
            left: -182px;
          }
          .state-info {
            left: -171px;
            top: -118px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-e1 {
          top: 135px;
          left: 775px;
          &::before {
            top: -30px;
            left: -238px;
            transform: rotate(45deg);
            width: 45px;
          }
          &:after {
            top: -46px;
            left: -246px;
          }
          .state-info {
            left: -374px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-e2 {
          top: 140px;
          left: 725px;
          &::before {
            top: -29px;
            left: -210px;
            transform: rotate(70deg);
            width: 40px;
          }
          &:after {
            top: -47px;
            left: -212px;
          }
          .state-info {
            left: -343px;
            top: -46px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-e3 {
          top: 150px;
          left: 422px;
          &::before {
            top: -29px;
            left: -229px;
            transform: rotate(55deg);
            width: 55px;
          }
          &:after {
            top: -52px;
            left: -232px;
          }
          .state-info {
            left: -363px;
            top: -51px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-e4 {
          top: 150px;
          left: 366px;
          &::before {
            top: -59px;
            left: -235px;
            transform: rotate(85deg);
            width: 120px;
          }
          &:after {
            top: -119px;
            left: -194px;
          }
          .state-info {
            left: -323px;
            top: -118px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-b1 {
          top: 307px;
          left: 875px;
          &::before {
            top: -15px;
            left: -200px;
            transform: rotate(235deg);
            width: 45px;
          }
          &:after {
            top: 3px;
            left: -165px;
          }
          .state-info {
            left: -150px;
            top: 3px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-b2 {
          top: 307px;
          left: 902px;
          &::before {
            top: -15px;
            left: -200px;
            transform: rotate(235deg);
            width: 45px;
          }
          &:after {
            top: 3px;
            left: -165px;
          }
          .state-info {
            left: -150px;
            top: 3px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-b3 {
          top: 230px;
          left: 1203px;
          &::before {
            top: -10px;
            left: -198px;
            transform: rotate(235deg);
            width: 55px;
          }
          &:after {
            top: 12px;
            left: -155px;
          }
          .state-info {
            left: -139px;
            top: 13px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-b4 {
          top: 270px;
          left: 1225px;
          &::before {
            top: -18px;
            left: -203px;
            transform: rotate(245deg);
            width: 120px;
          }
          &:after {
            top: 36px;
            left: -118px;
          }
          .state-info {
            left: -102px;
            top: 37px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-c1 {
          top: 307px;
          left: 731px;
          &::before {
            top: -15px;
            left: -200px;
            transform: rotate(305deg);
            width: 45px;
          }
          &:after {
            top: 3px;
            left: -204px;
          }
          .state-info {
            left: -335px;
            top: 3px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-c2 {
          top: 307px;
          left: 731px;
          &::before {
            top: -15px;
            left: -219px;
            transform: rotate(305deg);
            width: 45px;
          }
          &:after {
            top: 3px;
            left: -224px;
          }
          .state-info {
            left: -354px;
            top: 3px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-c3 {
          top: 230px;
          left: 402px;
          &::before {
            top: -10px;
            left: -210px;
            transform: rotate(305deg);
            width: 55px;
          }
          &:after {
            top: 12px;
            left: -213px;
          }
          .state-info {
            left: -340px;
            top: 13px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-c4 {
          top: 270px;
          left: 352px;
          &::before {
            top: -15px;
            left: -241px;
            transform: rotate(295deg);
            width: 125px;
          }
          &:after {
            top: 42px;
            left: -220px;
          }
          .state-info {
            left: -351px;
            top: 43px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .sensor-a1 {
          top: 60px;
          left: 616px;
          &::before {
            bottom: 30px;
            left: -6px;
            width: 70px;
            transform: rotate(133deg);
          }
          &::after {
            bottom: 56px;
            left: 52px;
          }
          .state-info {
            right: -171px;
            top: -41px;
          }
        }
        .sensor-a2 {
          top: 150px;
          left: 615px;
          &::before {
            bottom: -13px;
            left: -31px;
            width: 54px;
            transform: rotate(300deg);
          }
          &::after {
            bottom: -36px;
            left: -32px;
          }
          .state-info {
            right: 48px;
            top: 51px;
          }
        }
        .sensor-d1 {
          top: 60px;
          left: 635px;
          &::before {
            bottom: 30px;
            left: -8px;
            width: 55px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 54px;
            left: 32px;
          }
          .state-info {
            right: -154px;
            top: -39px;
          }
        }

        .sensor-d2 {
          z-index: -10;
          top: 136px;
          left: 770px;
          &::before {
            bottom: 65px;
            left: -37px;
            width: 130px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 126px;
            left: 50px;
          }
          .state-info {
            right: -170px;
            top: -111px;
          }
        }

        .sensor-d3 {
          top: 138px;
          left: 930px;
          &::before {
            bottom: 65px;
            left: -26px;
            width: 110px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 116px;
            left: 48px;
          }
          .state-info {
            right: -168px;
            top: -101px;
          }
        }

        .sensor-d4 {
          z-index: -10;
          top: 143px;
          left: 1105px;
          &::before {
            bottom: 34px;
            left: -17px;
            width: 70px;
            transform: rotate(115deg);
          }
          &::after {
            bottom: 66px;
            left: 32px;
          }
          .state-info {
            right: -153px;
            top: -50px;
          }
        }

        .sensor-e1 {
          top: 60px;
          left: 598px;
          &::before {
            bottom: 30px;
            left: -31px;
            width: 55px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 54px;
            left: -32px;
          }
          .state-info {
            right: 50px;
            top: -39px;
          }
        }

        .sensor-e2 {
          z-index: -10;
          top: 136px;
          left: 460px;
          &::before {
            bottom: 65px;
            left: -77px;
            width: 130px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 126px;
            left: -49px;
          }
          .state-info {
            right: 67px;
            top: -111px;
          }
        }

        .sensor-e3 {
          top: 140px;
          left: 305px;
          &::before {
            bottom: 66px;
            left: -68px;
            width: 110px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 117px;
            left: -47px;
          }
          .state-info {
            right: 65px;
            top: -102px;
          }
        }

        .sensor-e4 {
          z-index: -10;
          top: 143px;
          left: 143px;
          &::before {
            bottom: 33px;
            left: -38px;
            width: 70px;
            transform: rotate(65deg);
          }
          &::after {
            bottom: 65px;
            left: -32px;
          }
          .state-info {
            right: 49px;
            top: -50px;
          }
        }

        .sensor-b1 {
          top: 240px;
          left: 640px;
          &::before {
            bottom: 30px;
            left: -9px;
            width: 50px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 53px;
            left: 24px;
          }
          .state-info {
            right: -143px;
            top: -38px;
          }
        }

        .sensor-b2 {
          z-index: -10;
          top: 253px;
          left: 800px;
          &::before {
            top: 28px;
            left: 0px;
            transform: rotate(235deg);
            width: 45px;
          }
          &::after {
            bottom: -31px;
            left: 35px;
            width: 64px;
          }
          .state-info {
            right: -205px;
            top: 46px;
          }
        }

        .sensor-b3 {
          top: 204px;
          left: 930px;
          &::before {
            top: 53px;
            left: -24px;
            transform: rotate(250deg);
            width: 100px;
          }
          &::after {
            bottom: -85px;
            left: 43px;
          }
          .state-info {
            right: -160px;
            top: 100px;
          }
        }

        .sensor-b4 {
          top: 186px;
          left: 1105px;
          &::before {
            top: 32px;
            left: -9px;
            transform: rotate(245deg);
            width: 55px;
          }
          &::after {
            bottom: -43px;
            left: 30px;
          }
          .state-info {
            top: 59px;
            right: -150px;
          }
        }

        .sensor-c1 {
          top: 240px;
          left: 591px;
          &::before {
            bottom: 30px;
            left: -27px;
            width: 50px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 53px;
            left: -25px;
          }
          .state-info {
            right: 42px;
            top: -38px;
          }
        }

        .sensor-c2 {
          z-index: -10;
          top: 253px;
          left: 427px;
          &::before {
            top: 27px;
            left: -27px;
            transform: rotate(305deg);
            width: 45px;
          }
          &::after {
            bottom: -31px;
            left: -67px;
            width: 50px;
          }
          .state-info {
            right: 81px;
            top: 46px;
          }
        }

        .sensor-c3 {
          top: 206px;
          left: 305px;
          &::before {
            z-index: 10;
            top: 51px;
            left: -57px;
            transform: rotate(290deg);
            width: 100px;
          }
          &::after {
            bottom: -85px;
            left: -39px;
          }
          .state-info {
            right: 54px;
            top: 100px;
          }
        }

        .sensor-c4 {
          top: 188px;
          left: 143px;
          &::before {
            top: 37px;
            left: -33px;
            transform: rotate(295deg);
            width: 55px;
          }
          &::after {
            bottom: -48px;
            left: -32px;
          }
          .state-info {
            top: 64px;
            right: 49px;
          }
        }
      }
    }
  }
}
</style>